import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import {
  AdminCommercialOrderFormType,
  Buildings,
  CommercialDiscount,
  CommercialOrder,
  CommercialOrderInfoFormType,
  CommercialOrderPosition,
  CommercialOrderPositionFormType,
  CommercialPayment,
  CommercialPaymentFormType,
  CommercialService,
  CommercialServiceBuildingParameter,
  CommercialServiceCategory,
  CommercialServiceCategoryFormType,
  CommercialServiceFormType,
  CommercialWorkflowHistory,
} from "./data-contracts";

export const getAppBuildingGetbuildingsfromorganization = (organization: string, params?: IFetchConfig) =>
  fetch<Buildings[]>("GET", `commercial/organization/${organization}/building`, null, params);

export const getAppBuildingGetbuilding = (building: number, params?: IFetchConfig) =>
  fetch<Buildings>("GET", `commercial/building/${building}`, null, params);

export const putAppBuildingLinkservicestobuilding = (
  building: string,
  data: {
    serviceParameters?: {
      service?: number;
      ordered?: boolean;
      price?: number;
    }[];
  },
  params?: IFetchConfig,
) => fetch<Buildings>("PUT", `commercial/building/${building}/services`, data, params);

export const putAppBuildingCopyserviceparameters = (buildingTo: string, buildingFrom: string, params?: IFetchConfig) =>
  fetch<Buildings>("PUT", `commercial/building/${buildingTo}/services/copy_from/${buildingFrom}`, null, params);

export const deleteAppCommercialdiscountDeletediscount = (id: number, params?: IFetchConfig) =>
  fetch<CommercialDiscount>("DELETE", `commercial/discount/${id}`, null, params);

export const postAppCommercialorderCreateorderbyadmin = (data: AdminCommercialOrderFormType, params?: IFetchConfig) =>
  fetch<CommercialOrder>("POST", `commercial/order`, data, params);

export const getAppCommercialorderGetorderbyid = (id: number, params?: IFetchConfig) =>
  fetch<CommercialOrder>("GET", `commercial/order/${id}`, null, params);

export const postAppCommercialorderAddpositiontoorder = (
  id: number,
  data: CommercialOrderPositionFormType,
  params?: IFetchConfig,
) => fetch<CommercialOrderPosition>("POST", `commercial/order/${id}/position`, data, params);

export const putAppCommercialorderChangeorderinfo = (
  id: number,
  data: CommercialOrderInfoFormType,
  params?: IFetchConfig,
) => fetch<CommercialOrder>("PUT", `commercial/order/${id}/info`, data, params);

export const putAppCommercialorderEditposition = (
  id: number,
  data: CommercialOrderPositionFormType,
  params?: IFetchConfig,
) => fetch<CommercialOrderPosition>("PUT", `commercial/order/position/${id}`, data, params);

export const deleteAppCommercialorderDeleteposition = (id: number, params?: IFetchConfig) =>
  fetch<CommercialOrderPosition>("DELETE", `commercial/order/position/${id}`, null, params);

export const putAppCommercialorderSetexecutortoorder = (order: number, executor: number, params?: IFetchConfig) =>
  fetch<CommercialOrder>("PUT", `commercial/order/${order}/executor/${executor}`, null, params);

export const getAppCommercialorderGethistory = (order: number, params?: IFetchConfig) =>
  fetch<CommercialWorkflowHistory[]>("GET", `commercial/order/${order}/workflow`, null, params);

export const getAppCommercialorganizationGetorders = (
  id: number,
  query?: {
    page?: number;
    limit?: number;
    offset?: number;
    query?: string;
    sort?: string;
    visit_time_start?: string;
    visit_time_end?: string;
    order?: "DESC" | "ASC";
    statuses?: ("completed" | "appointed" | "new_order" | "rejected" | "in_work")[];
    executors?: number[];
    buildings?: number[];
    categories?: number[];
  },
  params?: IFetchConfig,
) =>
  fetch<{
    /** @example 250 */
    total: number;
    data: CommercialOrder[];
  }>("GET", `commercial/organization/${id}/order`, query, params);

export const postAppCommercialpaymentAddpayment = (
  id: number,
  data: CommercialPaymentFormType,
  params?: IFetchConfig,
) => fetch<CommercialPayment>("POST", `commercial/order/${id}/payment`, data, params);

export const deleteAppCommercialpaymentDeletepayment = (id: number, params?: IFetchConfig) =>
  fetch<CommercialPayment>("DELETE", `commercial/payment/${id}`, null, params);

export const getAppCommercialservicebuildingparameterGetcommercialservicebuildingparameters = (
  organization: string,
  query?: {
    buildings?: number[];
    categories?: number[];
    services?: number[];
  },
  params?: IFetchConfig,
) =>
  fetch<CommercialServiceBuildingParameter[]>(
    "GET",
    `commercial/organization/${organization}/service/building/parameter`,
    query,
    params,
  );

export const getAppCommercialservicecategoryGetcategoriesfromorganization = (
  organization: string,
  query?: {
    building?: number;
  },
  params?: IFetchConfig,
) => fetch<CommercialServiceCategory[]>("GET", `commercial/organization/${organization}/category`, query, params);

export const postAppCommercialservicecategoryCreatecategory = (
  organization: string,
  data: CommercialServiceCategoryFormType,
  params?: IFetchConfig,
) => fetch<CommercialServiceCategory>("POST", `commercial/organization/${organization}/category`, data, params);

export const getAppCommercialservicecategoryGetcategory = (category: string, params?: IFetchConfig) =>
  fetch<CommercialServiceCategory>("GET", `commercial/category/${category}`, null, params);

export const putAppCommercialservicecategoryUpdatecategory = (
  category: number,
  data: CommercialServiceCategoryFormType,
  params?: IFetchConfig,
) => fetch<CommercialServiceCategory>("PUT", `commercial/category/${category}`, data, params);

export const deleteAppCommercialservicecategoryDeletecategory = (category: string, params?: IFetchConfig) =>
  fetch<void>("DELETE", `commercial/category/${category}`, null, params);

export const putAppCommercialservicecategoryUpdatepositions = (
  organization: string,
  data: {
    categories?: number[];
  },
  params?: IFetchConfig,
) => fetch<void>("PUT", `commercial/organization/${organization}/category/position`, data, params);

export const getAppCommercialserviceGetarchiveservices = (organization: string, params?: IFetchConfig) =>
  fetch<CommercialService[]>("GET", `commercial/organization/${organization}/archive_services`, null, params);

export const getAppCommercialserviceGetservice = (service: string, params?: IFetchConfig) =>
  fetch<CommercialService>("GET", `commercial/service/${service}`, null, params);

export const putAppCommercialserviceUpdateservice = (
  service: string,
  data: CommercialServiceFormType,
  params?: IFetchConfig,
) => fetch<CommercialService>("PUT", `commercial/service/${service}`, data, params);

export const deleteAppCommercialserviceDeleteservice = (service: string, params?: IFetchConfig) =>
  fetch<void>("DELETE", `commercial/service/${service}`, null, params);

export const postAppCommercialserviceCreateservice = (
  category: string,
  data: CommercialServiceFormType,
  params?: IFetchConfig,
) => fetch<CommercialService>("POST", `commercial/category/${category}/service`, data, params);

export const putAppCommercialserviceUpdatepositions = (
  category: string,
  data: {
    services?: number[];
  },
  params?: IFetchConfig,
) => fetch<void>("PUT", `commercial/category/${category}/service/position`, data, params);

export const putAppCommercialserviceChangearchive = (
  service: string,
  data: {
    archive?: boolean;
  },
  params?: IFetchConfig,
) => fetch<void>("PUT", `commercial/service/${service}/archive`, data, params);

export const getAppCommercialserviceCheckpossibledelete = (service: number, params?: IFetchConfig) =>
  fetch<{
    possibleDelete?: boolean;
  }>("GET", `commercial/service/${service}/check`, null, params);

export const putAppCommercialworkflowAppointorder = (order: number, executor: number, params?: IFetchConfig) =>
  fetch<CommercialOrder>("PUT", `commercial/order/${order}/appointment/${executor}`, null, params);

export const putAppCommercialworkflowInworkorder = (order: number, params?: IFetchConfig) =>
  fetch<CommercialOrder>("PUT", `commercial/order/${order}/inwork`, null, params);

export const putAppCommercialworkflowCompleteorder = (
  order: number,
  data: {
    message?: string;
  },
  params?: IFetchConfig,
) => fetch<CommercialOrder>("PUT", `commercial/order/${order}/complete`, data, params);

export const putAppCommercialworkflowRejectorder = (
  order: number,
  data: {
    message?: string;
  },
  params?: IFetchConfig,
) => fetch<CommercialOrder>("PUT", `commercial/order/${order}/reject`, data, params);
